<template>
  <div>
    <div
      class="alert alert-custom alert-white alert-shadow fade show gutter-b"
      role="alert"
    >
      <div class="alert-icon">
        <i class="fas fa-info text-primary"></i>
      </div>
      <div class="alert-text">
        Selectionner un <strong>médicament</strong> pour changer sa
        disponibilité.
      </div>
    </div>
    <!--begin::Dashboard-->

    <div class="row">
           <div class="col-xl-4">
        <!--begin::Stats Widget 11-->
        <div class="card card-custom card-stretch gutter-b">
          <!--begin::Body-->
          <div class="card-body p-0">
            <div
              class="d-flex align-items-center justify-content-between card-spacer flex-grow-1"
            >
              <span class="symbol symbol-50 symbol-light-warning mr-2">
                <span class="symbol-label">
                  <i class="fas fa-capsules text-warning"></i>
                </span>
              </span>
              <div class="d-flex flex-column text-right">
                <span class="text-dark-75 font-weight-bolder font-size-h3"
                  >{{ medicinesCount.uponRequestMedicineNbr }} /
                  {{ medicinesCount.totalMedicineNbr }}</span
                >
                <span class="font-weight-bold mt-2"
                  >Médicaments à la demande</span
                >
              </div>
            </div>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Stats Widget 11-->
      </div>
      <div class="col-xl-4">
        <!--begin::Stats Widget 10-->
        <div class="card card-custom card-stretch gutter-b">
          <!--begin::Body-->
          <div class="card-body p-0">
            <div
              class="d-flex align-items-center justify-content-between card-spacer flex-grow-1"
            >
              <span class="symbol symbol-50 symbol-light-success mr-2">
                <span class="symbol-label">
                  <i class="fas fa-capsules text-success"></i>
                </span>
              </span>
              <div class="d-flex flex-column text-right">
                <span class="text-dark-75 font-weight-bolder font-size-h3"
                  >{{ medicinesCount.availableMedicineNbr }} /
                  {{ medicinesCount.totalMedicineNbr }}</span
                >
                <span class="font-weight-bold mt-2"
                  >Médicaments disponibles</span
                >
              </div>
            </div>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Stats Widget 10-->
      </div>
      <div class="col-xl-4">
        <!--begin::Stats Widget 11-->
        <div class="card card-custom card-stretch gutter-b">
          <!--begin::Body-->
          <div class="card-body p-0">
            <div
              class="d-flex align-items-center justify-content-between card-spacer flex-grow-1"
            >
              <span class="symbol symbol-50 symbol-light-danger mr-2">
                <span class="symbol-label">
                  <i class="fas fa-capsules text-danger"></i>
                </span>
              </span>
              <div class="d-flex flex-column text-right">
                <span class="text-dark-75 font-weight-bolder font-size-h3"
                  >{{ medicinesCount.notAvailableMedicineNbr }} /
                  {{ medicinesCount.totalMedicineNbr }}</span
                >
                <span class="font-weight-bold mt-2"
                  >Médicaments non disponibles</span
                >
              </div>
            </div>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Stats Widget 11-->
      </div>
 
    </div>

    <div class="row" ref="stats">
      <div class="col-xl-12">
        <!--begin::Base Table Widget 7-->
        <div class="card card-custom card-stretch gutter-b" id="page">
          <!--begin::Header-->
          <div class="card-header border-0 mt-5">
            <h3 class="card-title align-items-start flex-column text-dark">
              <span class="font-weight-bolder text-dark"
                >Liste des médicaments</span
              >
            </h3>
            <div class="card-toolbar"></div>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body py-0 mt-n3">
            <!--begin::Table-->
            <div>
               <a
                @click="setAvailability(3)"
                class="btn btn-warning font-weight-bolder font-size-sm mr-3"
                >Â la demande</a
              >
              <a
                @click="setAvailability(1)"
                class="btn btn-success font-weight-bolder font-size-sm mr-3"
                >Disponible</a
              >
              <a
                @click="setAvailability(2)"
                class="btn btn-danger font-weight-bolder font-size-sm mr-3"
                >Non disponible</a
              >
            </div>
            <br />
            <DxDataGrid
              @initialized="saveGridInstance"
              :data-source="dataSource"
              :remote-operations="true"
              :columns="columns"
              :show-row-lines="true"
              :word-wrap-enabled="true"
              :show-borders="true"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :row-alternation-enabled="false"
              :hover-state-enabled="true"
              :column-auto-width="true"
              :show-column-lines="true"
              :selection="{ mode: 'multiple' }"
              @selection-changed="onSelectionChanged"
            >
              >
              <DxFilterRow :visible="true" />

              <DxHeaderFilter :visible="true" :allow-search="true" />
              <!-- <DxStateStoring :enabled="true" type="localStorage" storage-key="medicineList" /> -->
              <DxPager
                :show-page-size-selector="true"
                :allowed-page-sizes="[5, 10, 20]"
              />
              <DxGroupPanel :visible="true" />
              <DxGrouping :auto-expand-all="true" />
              <DxPaging :page-size="10" />
              <DxSearchPanel :visible="true" />
              <DxSummary>
                <DxTotalItem
                  column="stateLabel"
                  summary-type="count"
                  display-format="{0}"
                />
              </DxSummary>
            </DxDataGrid>
            <br />
            <!--end::Table-->
          </div>
          <!--end::Body-->
        </div>
        <!--end::Base Table Widget 7-->
      </div>
    </div>
    <!--end::Dashboard-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import {
  DxDataGrid,
  //DxColumn,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxPaging,
  //DxStateStoring,
  DxPager,
  DxHeaderFilter,
  DxFilterRow,
  DxSummary,
  DxTotalItem,
} from "devextreme-vue/data-grid";
import { createStore } from "devextreme-aspnet-data-nojquery";
import SearchApiService from "../../../core/services/searchapi.service";
import MedicinesService from "../../../services/medicines.service";
import loaderHelper from "../../../helpers/loader.helper";
import SweetAlert2 from "../../../helpers/sweetAlert2.helper";
import AnalyticsService from "../../../services/analytics.service";
import DxHelper from "../../../helpers/dx.helper";

export default {
  name: "availability",
  components: {
    DxDataGrid,
    //DxColumn,
    DxGrouping,
    DxGroupPanel,
    DxSearchPanel,
    DxPaging,
    //DxStateStoring,
    DxPager,
    DxHeaderFilter,
    DxFilterRow,
    DxSummary,
    DxTotalItem,
  },
  data() {
    return {
      pharmacy: {},
      medicinesCount: {
        availableMedicineNbr: 0,
        notAvailableMedicineNbr: 0,
        uponRequestMedicineNbr: 0,
        totalMedicineNbr: 0,
      },
      dataSource: {},
      columns: [
        { dataField: "stateLabel", caption: "Etat" },
        {
          dataField: "designation",
          caption: " Designation",
          sortIndex: 0,
          sortOrder: "asc",
        },
        { dataField: "codeCNAS", caption: "CodeCNAS" },
        { dataField: "conditionnement", caption: "Conditionnement" },
        { dataField: "dci", caption: "DCI" },
        { dataField: "forme", caption: "Forme" },    
      ],
      selectedMedicinesIds: [],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Médicaments", route: "availability" },
      { title: "Disponibilité" },
    ]);

    this.dataSource = createStore({
      key: "guid",
      loadUrl: `${SearchApiService.baseURL}Availability`,
      onBeforeSend: DxHelper.onBeforeSend,
      onAjaxError : DxHelper.onAjaxError
    });

    this.getMedicinesCount();
  },
  methods: {
    getMedicinesCount: function () {
      AnalyticsService.getMedicinesCount().then(
        (result) => {
          this.medicinesCount = result.data;
        }
      );
    },
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },
    onSelectionChanged(e) {
      this.selectedMedicinesIds = e.selectedRowKeys;
    },
    setAvailability(state) {
      if (this.selectedMedicinesIds.length == 0) {
        SweetAlert2.warning("Alerte", "Selectionner au moins un médicament!");
        return;
      }

      var availability = {
        State: state,
        MedicineGuids: this.selectedMedicinesIds,
      };

      SweetAlert2.question("Voulez-vouz effectuer cette opération ?", "").then(
        (result) => {
          if (result.isConfirmed) {
            loaderHelper.show("page");
            MedicinesService.setAvailability(availability)
              .then(() => {
                this.dataGridInstance.refresh();
                this.dataGridInstance.deselectAll();

                this.getMedicinesCount();
                SweetAlert2.success("L'opération a réussi", "");
                loaderHelper.hide();
              })
              .catch(() => {
                loaderHelper.hide();
              });
          }
        }
      );
    },
  },
  computed: {
    ...mapGetters(["currentPharmacy"]),
  },
};
</script>
